// in UI: attribute filter = dynamic, custom filter = classification
export enum HierarchyMode {
	CLASSIFICATION = 'CLASSIFICATION',
	DYNAMIC_FILTERING = 'DYNAMIC_FILTERING'
}
